import { render, staticRenderFns } from "./security-mfa-setup.vue?vue&type=template&id=2a329daf&"
import script from "./security-mfa-setup.vue?vue&type=script&lang=js&"
export * from "./security-mfa-setup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports